import { Box } from '@mui/material';

import OperatingYearRow from '@Router/NatureOfBusiness/Components/IncomeStructure/OperatingYearRow';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { getBuddhistYear } from '@Utils/datetime';
import ExportIncomeTotalForm from './ExportIncomeTotalForm';
import ExportIncomeDetailForm from './ExportIncomeDetailForm';
import ExportIncomeExtendedForm from './ExportIncomeExtendedForm';
import ExportIncomeAddButton from './ExportIncomeActions/ExportIncomeAddButton';
import ExportIncomeTotalPct from './ExportIncomeTotalPct';
import ExportIncomeDetailPct from './ExportIncomeDetailPct';
import ExportIncomeExtendedPct from './ExportIncomeExtendedPct';

export const ExportIncomeForm = () => {
  const { progressData } = useProgressBar();

  const startOperatingYear =
    progressData?.report.startOperatingYear ?? getBuddhistYear();

  return (
    <Box mt={2}>
      <OperatingYearRow startOperatingYear={startOperatingYear} gap={1} />
      <ExportIncomeTotalForm />
      <ExportIncomeDetailForm />
      <ExportIncomeExtendedForm />
      <ExportIncomeAddButton />
      <Box mt={6} />
      <ExportIncomeTotalPct />
      <ExportIncomeDetailPct />
      <ExportIncomeExtendedPct />
    </Box>
  );
};
